/**
 * File service for fetching files from external URLs
 * All external client communications should go through this service
 */

export class FileService {
  /**
   * Fetch a file from a URL and return it as a Blob
   * @param url - The URL of the file to fetch
   * @returns Promise<Blob> - The file as a Blob
   * @throws Error if the fetch fails or response is not ok
   */
  // TODO: this will go to backend, not directly to datastorage service
  static async getFileBlob(url: string): Promise<Blob> {
    const response = await fetch(url);
    
    return await response.blob();
  }
}

